import moment from "moment";
import {DateFormats} from "../components/constants/securspace-constants";

export const generateSupplierInvoicesLinkFromTransaction = (
  invoiceNumber: string | number,
  createdOn: string
): string => {
  const link = '/finances/supplier-invoices';

  const params: string[] = [];
  if (invoiceNumber) {
    params.push(`invoiceNumber=${invoiceNumber}`);
  }

  if (createdOn) {
    const momentStartDate = moment(createdOn).subtract(1, 'days'); // Adjusting to the previous day to avoid odd timezone date edge cases
    if (momentStartDate.isValid()) {
      params.push(`startDate=${momentStartDate.format(DateFormats.DAY)}`);
    }
  }

  return link + (params.length > 0 ? '?' + params.join('&') : '');
};

export const generateLocationProfileLink = (
  locationId: string,
  showMonthFalse?: boolean
): string => {
  const queryParams = showMonthFalse ? '?showMonth=false' : '';
  return `/location-profile/${locationId}${queryParams}`;
};
